const routes = {
  routingCreate: "/routings/create",
  routingUpdate: "/routings/:id/update",
  routingDelete: "/routings/:id/delete",
  routingDetail: "/routings/:id",
  routingList: "/routings",
}

export default routes
